<template>
  <a-modal
      title="用户详细资料"
      :width="640"
      v-model="visible"
      :bodyStyle="{ maxHeight: '700px', overflowY: 'auto' }"
  >
    <a-form :form="form">
      <a-form-item
          label="姓名"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.realName }}
      </a-form-item>
      <a-form-item
          label="性别"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.gender? (formData.gender === 'male'? '男' : '女'): '' }}
      </a-form-item>
      <a-form-item
          label="学校"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.bizOrgName }}
      </a-form-item>
      <a-form-item
          label="手机号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.mobile }}
      </a-form-item>
      <a-form-item
          label="用户名"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.username }}
      </a-form-item>
      <a-form-item
          label="注册方式"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.registerType === 'self'? '自主注册' : '批量导入' }}
      </a-form-item>
      <a-form-item
          label="注册时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.created }}
      </a-form-item>
      <a-form-item
          label="学号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.personNo}}
      </a-form-item>
      <a-form-item
          label="年级"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.grade }}
      </a-form-item>
      <a-form-item
          label="班级"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.className }}
      </a-form-item>
      <a-form-item
          label="校园卡号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.cardNo }}
      </a-form-item>
      <a-form-item
          label="楼栋编号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.buildingNo }}
      </a-form-item>
      <a-form-item
          label="房间编号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.roomNo }}
      </a-form-item>
      <a-form-item
          label="会员状态"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        <a-tag v-if="formData.expired === null" color="#9c9b9b">
          未充值
        </a-tag>
        <a-tag v-else-if="formData.expired" color="red">
          已过期
        </a-tag>
        <a-tag v-else color="green">
          正常
        </a-tag>
      </a-form-item>
      <a-form-item
          label="会员有效期至"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.expireDate }}
      </a-form-item>
      <a-form-item
          label="衣袋号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.pocketNo }}
      </a-form-item>
      <template v-if="formData.labelNos && formData.labelNos.length > 0">
        <a-form-item
            v-for="(labelNo,index) in formData.labelNos"
            :key="labelNo"
            :label="'标签' + (index + 1)"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
        <a-tag color="green">{{labelNo}}</a-tag>
        </a-form-item>
        <a-form-item
            label="衣袋打印时间"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          {{ formData.printTime }}
        </a-form-item>
      </template>
      <a-form-item
          label="注册日期"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        {{ formData.created }}
      </a-form-item>
      <a-form-item
          v-if="photos.photoUrl"
          label="预存人脸"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
      >
        <img :src="photos.photoUrl" style="width: 220px; height: 250px;">
      </a-form-item>
      <template v-if="photos.recentDetails.length > 0">
        <a-form-item
            v-for="(info,index) in photos.recentDetails"
            :label="'最近人脸' + (index + 1)"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
        >
          <div>{{info.time}}</div>
          <img :src="'data:image/png;base64,' + info.img" style="width: 220px; height: 250px;">
        </a-form-item>
      </template>
    </a-form>
    <template #footer>
      <a-button key="submit" type="primary" @click="handleSubmit">
        确定
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import userService from "@/service/user"
export default {
  data() {
    return {
      labelCol: {
        xs: {span: 24},
        sm: {span: 7}
      },
      wrapperCol: {
        xs: {span: 24},
        sm: {span: 13}
      },
      visible: false,
      confirmLoading: false,

      form: this.$form.createForm(this),
      formData: {},

      photos: {}
    }
  },
  props: {
    formType: ''
  },
  methods: {
    showForm(formData) {
      this.form.resetFields()
      this.visible = true
      this.formData = formData

      userService.queryPhotos({id: formData.id}).then((res) => {
        this.photos = res.data
      });
    },

    handleSubmit() {
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    }
  },
}
</script>

<style scoped>
.ant-form-item {
  margin-bottom: 2px;
}
</style>
